import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { FaSignInAlt } from "react-icons/fa";

function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data ||
        "Greska prilikom prijavljivanja";
      setError(typeof msg === "string" ? msg : "Greska prilikom prijavljivanja");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h1 className="login-title">INFOTRADE</h1>
        <p className="login-subtitle">eFakture sistem</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Korisnicko ime</label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Unesite korisnicko ime"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Lozinka</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Unesite lozinku"
            />
          </div>
          {error && <div className="status-message error">{error}</div>}
          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? (
              "Prijavljivanje..."
            ) : (
              <>
                <FaSignInAlt style={{ marginRight: 8 }} /> Prijavi se
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
